import React from 'react';

import logo from 'app/assets/logo_MYFIN.svg';

export const LogoMyFin = () => (<img src={logo} alt="логотип MyFin" />);
